import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';

const Course = IPT.contains({
  id: PT.number.isRequired,
  slug: PT.string.isRequired,
  title: PT.string.isRequired,
  topics: IPT.listOf(PT.number).isRequired,
  teacher_name: PT.string.isRequired,
  curriculum_slug: PT.string.isRequired,

  // no longer used but in rest
  image_url: PT.string,
  product: PT.string,
  progress_info_url: PT.string,
});

const Topic = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  slug: PT.string.isRequired,
  lessons: IPT.listOf(PT.number),
});

const Lesson = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  key_knowledge_text: PT.string.isRequired,
  url: PT.string.isRequired,
  share_url: PT.string.isRequired,
  chunks: IPT.listOf(PT.number),
});

const Chunk = IPT.contains({
  id: PT.number.isRequired,
  index: PT.number.isRequired,
  url: PT.string.isRequired,
  has_quiz: PT.bool.isRequired,
  title: PT.string.isRequired,
  duration: PT.number.isRequired,
  group_with_last: PT.bool.isRequired,
});

const ExamQuestion = IPT.contains({
  id: PT.number,
  question_type: PT.string,
  number_of_lines: PT.number,
  marks: PT.string,
  vcaa_average: PT.string,
  difficulty: PT.any,
  question_level: PT.number,
  calculators_allowed: PT.bool,
  source: PT.any,
  related_lessons: IPT.list,
  instructions: PT.string,
  instructions_text: PT.string,
  image: PT.string,
});

const ExamSection = IPT.contains({
  id: PT.number.isRequired,
  serial: PT.string.isRequired,
  title: PT.string.isRequired,
  flatQuestions: PT.arrayOf(
    PT.shape({
      id: PT.number,
      fullSerial: PT.string,
      children: PT.array,
    })
  ),
});

const Exam = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  status: PT.oneOf(['OPEN', 'LOCKED_BY_TEACHER']),
  is_published: PT.bool.isRequired,
  is_submittable: PT.bool.isRequired,
  sittings: IPT.listOf(PT.number),
  marks_total: PT.number,
  start_exam_url: PT.string,
  share_url: PT.string,
  exam_url: PT.string,

  // not used but in the REST
  print_exam_url: PT.string,
  alt_title: PT.string,
  first_section_id: PT.number,
  offline_exam_url: PT.string,
  solution_url: PT.string,
});

const ExamResponse = IPT.contains({
  id: PT.number.isRequired,
  question_type: PT.string.isRequired,
  sitting: PT.number,
  reviewed_sitting: PT.number,
  responder: PT.number.isRequired,
  question: PT.number.isRequired,
  marks_final: PT.string,
  your_answer: PT.string,
  note: PT.string,
  comment_from_teacher: PT.string,
  grokked: PT.number,
  solution: PT.string,
});

const WistiaVideo = IPT.contains({
  id: PT.number.isRequired,
  wistia_hashed_id: PT.string.isRequired,
  title: PT.string.isRequired,
  duration: PT.number,
  thumbnail_url: PT.string,
});

const WistiaMedia = IPT.contains({
  created: PT.string, // datetime
  description: PT.string,
  duration: PT.number, // float
  hashed_id: PT.string,
  id: PT.number,
  name: PT.string,
  progress: PT.number,
  section: PT.string,
  status: PT.string,
  thumbnail: IPT.contains({
    height: PT.number,
    url: PT.string, // url
    width: PT.number,
  }),
  type: PT.string,
  updated: PT.string, // datetime
});

const Flags = PT.any;
const UserCourseProgress = PT.any;
const Sitting = PT.any;

export default {
  Course,
  Topic,
  Lesson,
  Chunk,
  ExamQuestion,
  ExamResponse,
  ExamSection,
  Exam,
  WistiaVideo,
  WistiaMedia,
  Sitting,
  UserCourseProgress,
  Flags,
};
